import { Token } from "../store/global/TokenEnum";
import { GlobalStore } from "../store/global/GlobalStore";
import { Balance } from "../store/global/getBalances";
import { Amount } from "../types/amount";

export const useBalanceForSymbol = (symbol: Token | undefined) => {
  const balance = GlobalStore.useState(s => s.balances).find(balance => balance.symbol === symbol);
  if (symbol == null) return undefined;
  if (balance != null) return balance;
  const zeroBalance: Balance = { symbol, balance: Amount.ZERO };
  return zeroBalance;
};
